import { filter, isEmpty } from 'lodash'
import { login } from '../store/modules'

export default
{
	data()
	{
		return {
			PORT_LAG_INTERFACES: null,

			ordersPortLag: []
		}
	},

	created()
	{
		this.fetchPortLagInterfaces()
	},

	methods:
	{
		fetchPortLagInterfaces()
		{
			if ( !isEmpty(this.PORT_LAG_INTERFACES) )
			{
				return new Promise.resolve(this.PORT_LAG_INTERFACES)
			}

			return this.$http.get('/api/lookup/port-lag-interfaces')
				.then(response => this.PORT_LAG_INTERFACES = response.data)
				.catch(response => this.PORT_LAG_INTERFACES = false)
		},

		portOrLagOrders(orders, questionnaireType)
		{
			const ipTypes = [ this.QUESTIONNAIRE_IPV4, this.QUESTIONNAIRE_IPV6 ]

			const orderIds = orders.map(({ id }) => id)

			return filter
			(
				orders,
				order => 
				{
					if ( !order )
					{
						return false
					}

					//vlan orders should be in the port/lag section. Only for bqp questionnaires.
					if ( ipTypes.includes(questionnaireType) && order.product_code?.includes?.('_VLAN_') )
					{
						return true
					}

					//don't include anything that has a parent order ID listed in the port/lag orders.
					if ( order.hasOwnProperty?.('parent_id') && orderIds.includes(order.parent_id) )
					{
						return false
					}

					//remove layer 2 orders unless l2q
					if ( order.product_code?.includes?.('_L2_') )
					{
						if ( questionnaireType == this.QUESTIONNAIRE_L2 && !order.product_code?.includes?.('_MPLS_') )
						{
							return true
						}
						return false
					}

					return this.PORT_LAG_INTERFACES?.includes?.(order.port_interface)
				}
			)
		},

		fetchPortLagAddresses(orders=[])
		{
			if ( isEmpty(orders) )
			{
				return Promise.reject(new Error("No Port/Lag Orders"))
			}

			return this.$http.post
			(
				'api/questionnaires/addresses',
				{
					orders: JSON.stringify(orders.map(({ id }) => id)),
				}
			)
		},
	},
}